module.exports = __webpack_public_path__ + "img/total-sessions-white.c085b018.svg";